import { Nationality } from '../../lib/types/models/country/nationality'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getNationalitiesList() {
  return restApiClient
    .url(constructApiUrl(API.countries.getNationalitiesList.url, null))
    .get<Nationality[]>()
}
